// import dependencies 
import { t } from 'i18next';
import React, { useState } from 'react'

// import assets 
import resetIcon from '../img/retake-icon.svg'
import unitIcon from '../img/unit-icon.svg'
import primariesIcon from '../img/primaries-icon.svg'
import secondariesIcon from '../img/secondaries-icon.svg'
import prvIcon from '../img/prv-icon.svg'
import pairingIcon from '../img/pairing-icon.svg'

// import utils 
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// import component 
import NoteTaker from '../components/NoteTaker'

const PairedUnit = ({submit,notes, setNotes, photos, handleRetakeBtnClick}) => {
    // component state 
    const [chosenPhoto, setChosenPhoto] = useState(null)

    const [showingNotePrompt, setShowingNotePrompt] = useState(false)
    const location = useLocation()

    const getIcon = (photoName) => {
        switch (photoName) {
            case 'unitPhoto': return unitIcon
            case 'primariesPhoto': return primariesIcon
            case 'secondariesPhoto': return secondariesIcon
            case 'prvPhoto': return prvIcon
            case 'pairingPhoto': return pairingIcon
            default : return 'unitPhoto'
        }
    }

    const getUrl = (photoName) => {
        switch (photoName) {
            case 'unitPhoto': return 'unit-photo'
            case 'primariesPhoto': return 'primaries-photo'
            case 'secondariesPhoto': return 'secondaries-photo'
            case 'prvPhoto': return 'prv-photo'
            case 'pairingPhoto': return 'pairing-photo'
            default : return 'unit-photo'
        }
    }

    useEffect(() => {
        const handle = () => {
            // photos not defined just return 
            if(!photos) return 
            if(photos.length < 1) return

            // if coming from retake 
            const retakePhotoType = location.state?.fromRetake
            
            if(retakePhotoType){
                // find the photo 
                const foundPhoto = photos.find(photo => photo.key === retakePhotoType)
                if(foundPhoto){
                    setChosenPhoto(foundPhoto)
                } else{
                    setChosenPhoto(photos[0])
                }
                location.state = undefined
                return
            }
        
            // no chosen photo so just select the first one 
            if(!chosenPhoto){
                setChosenPhoto(photos[0])
                return
            }
        } 
        handle()
    }, [JSON.stringify(photos),chosenPhoto,location])

    const handlePhotoClick = photo => {
        setChosenPhoto(photo)
    }

    return (
        <>
            <div className={`full-page full-page-slim container paired-unit-container ${showingNotePrompt ? '' :'overflow-scroll'} `}>
                {photos && photos.length > 0 && chosenPhoto && ( 
                        <div className="row">
                            <div className="col-9 pe-1 position-relative main-preview">
                                
                                {chosenPhoto && <>
                                    <img className={`img-fluid photos w-100`} src={chosenPhoto.value} alt={chosenPhoto.key} />
                                </>}
                                <div className='position-absolute d-flex flex-column'>
                                    <img className="mb-2" src={getIcon(chosenPhoto.key)} alt=""/>
                                    <img className="reset-btn" src={resetIcon} alt="reset-button" onClick={() => handleRetakeBtnClick(getUrl(chosenPhoto.key))}/>
                                </div>
                            </div>
                            <div className="col-3 ps-1 gallery">
                                {photos.filter(photo => photo.value).map(photo => {
                                    return <div key={photo.key} className={`${photo.key === chosenPhoto.key ? 'preview-selected' : ''}`}>
                                        <img className={`img-fluid photos my-1 border border-right`} 
                                            src={photo.value} alt={photo.key} onClick={() => handlePhotoClick(photo)}/>
                                    </div>
                                } )}
                            </div>
                        </div>
                )}
                <div className="d-flex justify-content-around mt-4">
                    <button className='btn btn-primary text-light fw-bold standard-btn' onClick={submit}>{t('continue')}</button>
                </div>
                <div className='mt-5'>
                    <NoteTaker title={true} notes={notes} setNotes={(notes) => setNotes(notes)} setShowingPrompt={setShowingNotePrompt}/>
                </div>
                
            </div>
        </>

    )
}

export default PairedUnit